module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////1SsvH4AAAAYdFJOUwDG9NoXO0DtBw2cJe53/S7Tdvfn5rfgZ6XQncQAAABOSURBVBjTY2AAAw5xUREhZi5uIJNdAgiExSTAgImNgUECBfBwoglICKILMEIFeFn4BcAMdqgA0HRWMIMPIcABZcEFGAZWgB3iYFhAsAMA/1YTQLd3o2UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-client-landing-page--expanded--review-path-5@2x.png
// module id = 172
// module chunks = 0